import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion } from 'framer-motion';
import { Gift, Wind, HeartHandshake, CheckCircle, Sparkles, Shield, Brain, Clock, Users } from 'lucide-react';
export function BonusSection() {
  return <section className="py-8 px-4 bg-gradient-to-b from-[#FFF5F7] to-[#FEF0F3] relative overflow-hidden" data-id="element-10">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#f4b8c8] rounded-full mix-blend-multiply filter blur-[100px] opacity-20 pointer-events-none" data-id="element-11"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#d4c0e8] rounded-full mix-blend-multiply filter blur-[100px] opacity-15 pointer-events-none" data-id="element-12"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-8" data-id="element-15">
            <div className="inline-flex items-center gap-2 bg-[#c4607a]/10 px-4 py-2 rounded-full mb-4" data-id="element-16">
              <Gift className="w-4 h-4 text-[#c4607a]" data-id="element-17" />
              <span className="text-sm uppercase tracking-widest text-[#c4607a] font-semibold" data-id="element-18">
                Regalos Exclusivos
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-serif text-[#2d1520] mb-6" data-id="element-19">
              Esto no termina en la guía. <br data-id="element-20" />
              <span className="text-[#c4607a]" data-id="element-21">
                Te llevás todo esto también.
              </span>
            </h2>
            <p className="text-xl text-[#7a5568] max-w-2xl mx-auto" data-id="element-22">
              Herramientas diseñadas para los momentos donde la teoría no
              alcanza y necesitás una solución inmediata.
            </p>
          </div>
        </FadeIn>

        {/* Main Bonus Image */}
        <div className="mb-10 flex justify-center" data-id="element-23">
          <FadeIn delay={0.2} data-id="element-24">
            <motion.div className="relative" initial={{
            y: 20,
            opacity: 0
          }} whileInView={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} data-id="element-25">
              <div className="absolute inset-0 bg-[#c4607a] blur-[60px] opacity-20 rounded-full transform scale-90" data-id="element-26"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1Aq8eboiNiKUTwPgfdUqJb/imagen_de_los_bonos_(2).png" alt="Bonos: Antes de Hablar, Respirá y El Juego de la Conexión Real" className="relative w-full max-w-4xl rounded-2xl shadow-[0_20px_60px_rgba(196,96,122,0.15)] transform hover:scale-[1.01] transition-transform duration-500" data-id="element-27" />
            </motion.div>
          </FadeIn>
        </div>

        {/* Bonus 1 */}
        <div className="mb-10" data-id="element-28">
          <FadeIn data-id="element-29">
            <div className="bg-white rounded-3xl border border-[#f0d0dc] shadow-[0_12px_40px_rgba(196,96,122,0.08)] overflow-hidden" data-id="element-30">
              <div className="p-8 md:p-12" data-id="element-31">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12" data-id="element-32">
                  <div className="flex-1 space-y-6" data-id="element-33">
                    <div className="flex items-center gap-3" data-id="element-34">
                      <div className="bg-[#c4607a]/10 p-3 rounded-xl" data-id="element-35">
                        <Wind className="w-8 h-8 text-[#c4607a]" data-id="element-36" />
                      </div>
                      <div data-id="element-37">
                        <span className="text-sm font-bold text-[#c4607a] uppercase tracking-wider block" data-id="element-38">
                          Bono 1
                        </span>
                        <h3 className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-39">
                          Antes de Hablar, Respirá
                        </h3>
                      </div>
                    </div>

                    <div className="bg-[#FEF0F3] p-4 rounded-lg border border-[#f0d0dc] inline-block" data-id="element-40">
                      <p className="text-[#7a5568] font-medium" data-id="element-41">
                        Valor real:{' '}
                        <span className="line-through opacity-60" data-id="element-42">$47.000</span>{' '}
                        —{' '}
                        <span className="text-[#c4607a] font-bold" data-id="element-43">
                          Hoy incluido sin costo adicional
                        </span>
                      </p>
                    </div>

                    <p className="text-xl font-serif text-[#4a2535] italic" data-id="element-44">
                      El método interno para calmar tus emociones antes de decir
                      algo que no podés desdecir
                    </p>

                    <div className="space-y-4 text-[#7a5568] leading-relaxed" data-id="element-45">
                      <p data-id="element-46">
                        Hay algo que nadie te explicó sobre las peleas de
                        pareja.
                      </p>
                      <p data-id="element-47">
                        No es lo que decís lo que más daño hace. Es el estado
                        emocional desde el que lo decís.
                      </p>
                      <p data-id="element-48">
                        Podés tener las mejores intenciones. Podés querer
                        comunicarte mejor. Podés haber leído todo el libro.
                      </p>
                      <p data-id="element-49">
                        Pero si hablás cuando estás activada, herida o enojada…
                        la conversación ya empieza torcida.
                      </p>
                      <p className="font-medium text-[#4a2535]" data-id="element-50">
                        Antes de Hablar, Respirá es el recurso que evita que el
                        conflicto escale antes de empezar.
                      </p>
                    </div>

                    <div className="bg-[#FFF5F7] p-6 rounded-2xl border border-[#f0d0dc]" data-id="element-51">
                      <h4 className="font-serif text-lg text-[#2d1520] mb-4 flex items-center gap-2" data-id="element-52">
                        <Sparkles className="w-5 h-5 text-[#c4607a]" data-id="element-53" />
                        En este bono vas a aprender:
                      </h4>
                      <ul className="space-y-3" data-id="element-54">
                        {['Cómo identificar cuándo tu sistema nervioso está en modo ataque', 'Qué señales corporales indican que no es momento de hablar', 'El protocolo de pausa consciente en 5 pasos', 'Cómo diferenciar emoción actual de herida vieja', 'Cómo prepararte para conversaciones difíciles sin explotar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-55">
                            <CheckCircle className="w-5 h-5 text-[#c4607a] shrink-0 mt-0.5" data-id="element-56" />
                            <span className="text-[#7a5568]" data-id="element-57">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="space-y-4 text-[#7a5568] leading-relaxed border-t border-[#f0d0dc] pt-6" data-id="element-58">
                      <p data-id="element-59">Este no es un complemento opcional.</p>
                      <p data-id="element-60">
                        Es la pieza que hace que todo el método funcione incluso
                        en los días difíciles.
                      </p>
                      <p data-id="element-61">
                        Si este recurso se vendiera por separado, tendría un
                        valor mínimo de $27.000. Porque evita discusiones
                        innecesarias, palabras que duelen y distancias que luego
                        cuestan semanas reparar.
                      </p>
                      <p data-id="element-62">Pero hoy no lo vas a pagar.</p>
                      <p data-id="element-63">
                        Está incluido sin costo adicional dentro de tu acceso.
                      </p>
                      <p data-id="element-64">
                        No para que lo leas una vez. Sino para que lo uses cada
                        vez que sientas que la conversación puede irse de las
                        manos.
                      </p>
                      <p className="text-[#c4607a] font-serif text-lg" data-id="element-65">
                        Porque aprender a hablar mejor es importante. Pero
                        aprender a regularte antes de hablar lo cambia todo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Bonus 2 */}
        <div data-id="element-66">
          <FadeIn data-id="element-67">
            <div className="bg-white rounded-3xl border border-[#f0d0dc] shadow-[0_12px_40px_rgba(196,96,122,0.08)] overflow-hidden" data-id="element-68">
              <div className="p-8 md:p-12" data-id="element-69">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12" data-id="element-70">
                  <div className="flex-1 space-y-6" data-id="element-71">
                    <div className="flex items-center gap-3" data-id="element-72">
                      <div className="bg-[#c4607a]/10 p-3 rounded-xl" data-id="element-73">
                        <HeartHandshake className="w-8 h-8 text-[#c4607a]" data-id="element-74" />
                      </div>
                      <div data-id="element-75">
                        <span className="text-sm font-bold text-[#c4607a] uppercase tracking-wider block" data-id="element-76">
                          Bono 2
                        </span>
                        <h3 className="text-2xl md:text-3xl font-serif text-[#2d1520] font-bold" data-id="element-77">
                          El Juego de la Conexión Real
                        </h3>
                      </div>
                    </div>

                    <div className="bg-[#FEF0F3] p-4 rounded-lg border border-[#f0d0dc] inline-block" data-id="element-78">
                      <p className="text-[#7a5568] font-medium" data-id="element-79">
                        Valor real:{' '}
                        <span className="line-through opacity-60" data-id="element-80">$47.000</span>{' '}
                        —{' '}
                        <span className="text-[#c4607a] font-bold" data-id="element-81">
                          Hoy incluido sin costo adicional
                        </span>
                      </p>
                    </div>

                    <p className="text-xl font-serif text-[#4a2535] italic" data-id="element-82">
                      Dinámicas simples para reconectar en pareja sin tener que
                      hablar de problemas
                    </p>

                    <div className="space-y-4 text-[#7a5568] leading-relaxed" data-id="element-83">
                      <p data-id="element-84">
                        Hay parejas que no se separan por falta de amor. Se
                        desgastan por exceso de conversaciones pesadas.
                      </p>
                      <p data-id="element-85">
                        "Tenemos que hablar" se vuelve una amenaza. Todo gira
                        alrededor de conflictos. Y la conexión empieza a
                        desaparecer.
                      </p>
                      <p data-id="element-86">
                        El Juego de la Conexión Real nace para resolver eso.
                      </p>
                      <p className="font-medium text-[#4a2535]" data-id="element-87">
                        No es un libro para analizar la relación. Es una
                        experiencia para volver a sentirse cerca.
                      </p>
                    </div>

                    <div className="bg-[#FFF5F7] p-6 rounded-2xl border border-[#f0d0dc]" data-id="element-88">
                      <h4 className="font-serif text-lg text-[#2d1520] mb-4 flex items-center gap-2" data-id="element-89">
                        <Users className="w-5 h-5 text-[#c4607a]" data-id="element-90" />
                        En este bono vas a encontrar:
                      </h4>
                      <ul className="space-y-3" data-id="element-91">
                        {['Micro dinámicas diarias de 5 minutos', 'Preguntas que abren sin generar defensa', 'Rituales simples para parejas con poco tiempo', 'Ejercicios para reconectar después de una pelea', 'Adaptaciones reales para parejas con hijos y rutina intensa'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-92">
                            <CheckCircle className="w-5 h-5 text-[#c4607a] shrink-0 mt-0.5" data-id="element-93" />
                            <span className="text-[#7a5568]" data-id="element-94">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="bg-[#c4607a]/5 p-6 rounded-xl border-l-4 border-[#c4607a]" data-id="element-95">
                      <p className="text-[#4a2535] italic" data-id="element-96">
                        Este recurso está diseñado para algo muy concreto:{' '}
                        <br data-id="element-97" />
                        <span className="font-bold" data-id="element-98">
                          Que vuelvan a sentirse equipo sin necesidad de
                          discutir nada.
                        </span>
                      </p>
                    </div>

                    <div className="space-y-4 text-[#7a5568] leading-relaxed border-t border-[#f0d0dc] pt-6" data-id="element-99">
                      <p data-id="element-100">
                        Si se ofreciera como producto independiente, su valor
                        sería de $27.000. Porque transforma la atmósfera
                        emocional de la relación sin esfuerzo terapéutico.
                      </p>
                      <p data-id="element-101">Pero hoy no lo vas a pagar.</p>
                      <p data-id="element-102">Está incluido sin costo adicional.</p>
                      <p data-id="element-103">
                        Para que no todo en tu relación sea resolver problemas.
                        Para que también haya momentos livianos. Para que la
                        conexión no dependa siempre de una conversación
                        profunda.
                      </p>
                      <p className="text-[#c4607a] font-serif text-lg" data-id="element-104">
                        Porque a veces no hace falta entender más. Hace falta
                        volver a sentirse cerca.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}